import { actionCreators } from './actionCreators';
import { reducer } from './reducer';

const menuDetailsStore = {
    actionCreators,
    reducer,
};

export default menuDetailsStore;
